import React from 'react';
import styled from 'styled-components';
import { useNavigate, useParams } from 'react-router-dom';

import FormContainer from '../../components/UI/FormContainer';
import { FormTitle, Field } from '../../components/UI/Form';
import OrderItem from '../../components/UI/OrderItem';

import { useFetch } from '../../hooks/useFetch';
import { orderApi } from '../../api/order';
import { ORDER_STATUS, MALL_ACCOUNT } from '../../utils/constants';

const Container = styled.div`
	width: 90%;
	max-width: 900px;
	display: flex;
	flex-direction: column;
	padding-top: 30px;
`;

/*
data 구조
{
    "products": [
        {
            "productCode": "1",
            "productName": "6.5",
            "productThumbnail": "https://ywcnp.com",
            "quantity": 2,
            "price": 26000,
            "shippingFee": 4000
        }
    ],
    "orderInfo": {
        "orderNumber": "20251205-094834777543",
        "name": "김영원",
        "contact": "01012341234",
        "email": "temp123456@gmail.com",
        "orderStatus": "AWAITING_DEPOSIT",
		"orderDate": "2025-12-05T09:48:34"
    },
    "shippingInfo": {
        "name": "김영원",
        "contact": "01043214321",
        "postalCode": "12345",
        "roadAddress": "충북 음성군 대소면 대금로 511번길 96-5",
        "detailAddress": "상세주소",
        "memo": "배송메모"
    },
    "paymentInfo": {
        "totalPrice": 134000,
        "productsPrice": 106000,
        "shippingFee": 28000,
        "depositor": null
    },
    "receiptInfo": {
        "type": "PERSONAL_PHONE",
        "info": "01012341234"
    }
}
*/

export default function OrderDetail() {
	const param = useParams();
	const orderNumber = param.orderNumber;
	const navigate = useNavigate

	const { data, loading, error } = useFetch(orderApi.getOrderDetail, [orderNumber]);

	if (loading) {
		return ;
	}

	if (error) {
		alert('주문 상세 정보를 불러오는 도중 오류가 발생했습니다.');
		navigate('/my/orders', { replace: true });
	}

	return (
		<Container>
			<OrderInfo data={ data.orderInfo }/>
			<OrderItems data={ data } />
			<ShippingInfo data={ data.shippingInfo } orderNumber={orderNumber} />
			<PaymentInfo data={ data.paymentInfo }/>
		</Container>
  	);
}

function OrderInfo({data}) {
	const onClickCancelOrder = (orderNumber) => {
		if(!window.confirm('정말로 주문을 취소하시겠습니까?')) {
			return;
		}

		if(!(data.orderInfo.orderStatus === 'AWAITING_DEPOSIT' || data.orderInfo.orderStatus === 'PREPARING_FOR_SHIPMENT')) {
			alert('배송이 시작된 주문은 취소할 수 없습니다. ');
			return;
		}

		orderApi.cancelOrder(orderNumber)
			.then((response) => {
				alert('주문이 취소되었습니다.');
				window.location.reload();
			})
			.catch((error) => {
				alert('주문 취소 중 오류가 발생했습니다. 다시 시도해주세요.');
			});
	};

	return (
		<FormContainer>
			<FormTitle>주문 정보</FormTitle>
			<Field title="주문번호" value={ data.orderNumber } />
			<Field title="주문일시" value={ `${data.orderDate.split('T')[0]} ${data.orderDate.split('T')[1]}` } />
			<Field title="주문자" value={ data.name } />
			<Field title="주문처리상태"
				type="button"
				value={ ORDER_STATUS[data.orderStatus].label }
				buttonText='주문취소'
				onClick={ () => { onClickCancelOrder(data.orderNumber); } }
			/>
		</FormContainer>
	);
}

function OrderItems({ data }){
	const products = data.products || [];
	const extraInfo = {
		orderStatus: data.orderInfo.orderStatus,
		courierCompany: data.shippingInfo.courierCompany,
		trackingNumber: data.shippingInfo.trackingNumber
	};

	return (
		<FormContainer>
			<FormTitle>주문 상품</FormTitle>
			{ products.map((product, index) => (
				<OrderItem
					key={ index }
					data={ product }
					extraInfo={ extraInfo }
					isDetailView={ true }
				/>
			))}
		</FormContainer>
	);
}

function ShippingInfo({ data, orderNumber })  {
	const onClickChangeAddress = (orderNumber, nowAddress) => {		
		if(data.orderInfo.orderStatus !== 'AWAITING_DEPOSIT') {
			alert('배송 준비가 완료된 주문은 배송지 변경이 불가능합니다.');
			return;
		}

		window.open(`/popUp/${ orderNumber }/delivery-address?nowAddress=${encodeURIComponent(nowAddress)}`, 'popUp', 'width=800, height=500, top=200, left=500');
	};

	return (
		<FormContainer>
			<FormTitle>배송지 정보</FormTitle>
			<Field title="받으시는 분" value={ data.name } />
			<Field title="주소"
				type="button"
				value={ `${data.roadAddress} ${data.detailAddress}` }
				buttonText="배송지 변경"
				onClick={ () => { onClickChangeAddress(orderNumber, `${data.roadAddress} ${data.detailAddress}`); } }
			/>
			<Field title="연락처" value={ data.contact.replace(/^(\d{2,3})(\d{3,4})(\d{4})$/, `$1-$2-$3`) } />
			<Field title="배송 요청사항" value={ data.memo } />
		</FormContainer>
	);
}

function PaymentInfo({data}) {
	return (
		<FormContainer>
			<FormTitle>결제 정보</FormTitle>
			<Field title="총 주문금액" value={ `${data.totalPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}원` } />
			<Field title="총 결제금액" value={ `${data.totalPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}원` } />
			<Field title="결제수단"
				value={ ["무통장입금",
					`${MALL_ACCOUNT.BANK_NAME} ${MALL_ACCOUNT.ACCOUNT_NUMBER} ${MALL_ACCOUNT.ACCOUNT_HOLDER}`
				] } />
		</FormContainer>
	);
}